import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { veersaLogo } from "../../common/icons";
import { useAzureADAuth } from "../../config/use-azure-ad";
import { dashboardURL } from "../../routes/routes";
import "./loginPage.css";
import { dashboardImage } from "../../common/icons";
import Cookies from 'universal-cookie';
import { getLocalStorageItem } from "../../common/utils/local-storage";
import { ACCESS_TOKEN } from "../../common/constants/local-storage-keys";

const cookies = new Cookies();

export const LoginPage = () => {
  const { 
    loginAzureAD, 
    isLoading, 
    error, 
    clearError, 
    compatibilityMessages,
    authStrategy
  } = useAzureADAuth();
  const navigate = useNavigate();

  const handleLogin = () => {
    clearError(); // Clear any previous errors
    loginAzureAD();
  };
  
  useEffect(() => {
    document.title = "Veersa Portal";
  }, [])

  useEffect(() => {
    if(getLocalStorageItem(ACCESS_TOKEN)){
      navigate(dashboardURL);
    }
  }, []);

  return (
    <div className="loginPage">
      <div className="leftDiv">
        <div className="leftDivText">
          <img src={veersaLogo} alt="" className="login-logo" />
          <div className="mainHeadingmobile">
          Welcome back
          <br />
          <div className="subHeading1mobile">Nice to see you again</div>
        </div>
        
        {/* Error message display */}
        {error && (
          <div style={{
            backgroundColor: '#ffebee',
            color: '#c62828',
            padding: '12px',
            borderRadius: '4px',
            margin: '16px 0',
            border: '1px solid #ffcdd2',
            fontSize: '14px'
          }}>
            {error}
          </div>
        )}

        {/* Browser-specific guidance */}
        {compatibilityMessages.map((message, index) => (
          <div 
            key={index}
            style={{
              backgroundColor: message.type === 'info' ? '#e3f2fd' : '#fff3e0',
              color: message.type === 'info' ? '#1565c0' : '#ef6c00',
              padding: '12px',
              borderRadius: '4px',
              margin: '16px 0',
              border: `1px solid ${message.type === 'info' ? '#bbdefb' : '#ffcc02'}`,
              fontSize: '13px'
            }}
          >
            {message.message}
          </div>
        ))}

        {/* Authentication strategy info */}
        {authStrategy.preferRedirect && (
          <div style={{
            backgroundColor: '#f3e5f5',
            color: '#7b1fa2',
            padding: '10px',
            borderRadius: '4px',
            margin: '12px 0',
            border: '1px solid #e1bee7',
            fontSize: '12px'
          }}>
            Optimized login flow selected for your browser/platform
          </div>
        )}

        <button 
          className="loginBtn" 
          onClick={() => handleLogin()}
          disabled={isLoading}
          style={{
            opacity: isLoading ? 0.7 : 1,
            cursor: isLoading ? 'not-allowed' : 'pointer'
          }}
        >
          {isLoading ? 'Signing in...' : 'Login'}
        </button>
        </div>
      </div>
      <div className="rightDiv">
        <div className="mainHeading">
          Welcome back
          <br />
        </div>
        <div className="subHeading1">Nice to see you again</div>
        <img src={dashboardImage} alt="" className="dashboard-image" />       
      </div>
    </div>
  );
};

export default LoginPage;
